import t from "@emotion/styled/base";
import { Text as e } from "../../../Text/index.js";
function d() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const n = /* @__PURE__ */ t(e, process.env.NODE_ENV === "production" ? {
  target: "ei11ic10"
} : {
  target: "ei11ic10",
  label: "CountText"
})(process.env.NODE_ENV === "production" ? {
  name: "aakjv1",
  styles: "justify-content:flex-end;text-align:right;width:100%;max-width:fit-content"
} : {
  name: "aakjv1",
  styles: "justify-content:flex-end;text-align:right;width:100%;max-width:fit-content/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvTnVtYmVySW5wdXQvc3ViQ29tcG9uZW50cy9Db3VudC9Db3VudC5zdHlsZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSXFDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvTnVtYmVySW5wdXQvc3ViQ29tcG9uZW50cy9Db3VudC9Db3VudC5zdHlsZWQudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IFRleHQgfSBmcm9tICcuLy4uLy4uLy4uLy4uL2NvbXBvbmVudHMvVGV4dCc7XG5cbmV4cG9ydCBjb25zdCBDb3VudFRleHQgPSBzdHlsZWQoVGV4dClgXG4gICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgICB0ZXh0LWFsaWduOiByaWdodDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBtYXgtd2lkdGg6IGZpdC1jb250ZW50O1xuYDtcbiJdfQ== */",
  toString: d
});
export {
  n as CountText
};
